import { Dispatch } from '@reduxjs/toolkit';
import { setFilters } from '../prospect-slice';

/**
 * Applies prospect filters using the appliedProspectEnrichmentFilters from API response
 * @param dispatch - Redux dispatch function
 * @param appliedProspectEnrichmentFilters - Filter data from API response - /contacts/ai-columns
 * @param currentFilters - Current filter state
 */
export const applyProspectFiltersFromAPI = (
  dispatch: Dispatch,
  appliedProspectEnrichmentFilters: any,
  currentFilters: any
) => {
  if (!appliedProspectEnrichmentFilters) {
    return;
  }

  // Create payload similar to onApplyFilters function in prospect-filters-modal.tsx
  const payload = {
    ...currentFilters,
    pageNum: 1,
    filterGroupLogic: appliedProspectEnrichmentFilters,
    shouldFetchProspectList: true,
    shouldFetchProspectListCount: true,
    shouldFetchSavedFilters: true,
  };

  // Dispatch the setFilters action
  dispatch(setFilters(payload));
};
